import React, { useEffect, useState } from 'react';
import { Activity, Download, FileUp, Loader2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { serviceDeliveryAPI, clientPortalAPI } from '../lib/api';

const BRIEFING = { pendiente: 'Pendiente', en_proceso: 'En proceso', completado: 'Completado' };
const PAGO = { sepa: 'SEPA', transferencia: 'Transferencia' };
const fmt = (iso) => (iso ? new Date(iso).toLocaleString('es-ES', { dateStyle: 'medium', timeStyle: 'short' }) : '');

const Summary = ({ d }) => (
  <div className="flex flex-wrap gap-2 text-sm" data-testid="activity-summary">
    <Badge variant="outline" data-testid="activity-briefing">Briefing: {BRIEFING[d.briefing_status] || d.briefing_status}</Badge>
    <Badge variant="outline" data-testid="activity-pago">Forma de pago: {PAGO[d.forma_pago] || 'sin elegir'}</Badge>
    <Badge variant="outline" data-testid="activity-discord">Discord: {d.discord_joined ? 'se ha unido' : 'sin confirmar'}</Badge>
  </div>
);

const Uploads = ({ items }) => (
  <div className="space-y-2" data-testid="activity-uploads">
    <p className="text-sm font-medium flex items-center gap-2"><FileUp className="w-4 h-4" />Archivos que ha subido el cliente ({items.length})</p>
    {items.length === 0 ? <p className="text-sm text-muted-foreground">Todavía no ha subido ningún archivo.</p> : items.map((d) => (
      <div key={d.id} className="flex items-center justify-between gap-3 p-2.5 rounded-lg border" data-testid={`activity-upload-${d.id}`}>
        <div className="min-w-0"><p className="text-sm font-medium truncate">{d.nombre}</p><p className="text-xs text-muted-foreground">{fmt(d.created_at)}</p></div>
        <a href={clientPortalAPI.docDownloadUrl(d.id)} target="_blank" rel="noreferrer"><Button size="sm" variant="outline"><Download className="w-4 h-4 mr-1" />Descargar</Button></a>
      </div>
    ))}
  </div>
);

export default function ClientPortalActivity({ clientId }) {
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); serviceDeliveryAPI.getClientActivity(clientId).then(setD).catch(() => setD({ events: [], uploads: [] })); }, [clientId]);
  if (!d) return <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  return (
    <Card data-testid="client-portal-activity">
      <CardHeader><CardTitle className="flex items-center gap-2"><Activity className="w-5 h-5 text-primary" />Actividad en su portal</CardTitle></CardHeader>
      <CardContent className="space-y-6">
        {d.briefing_status !== undefined && <Summary d={d} />}
        <Uploads items={d.uploads || []} />
        <div className="space-y-2" data-testid="activity-events">
          <p className="text-sm font-medium">Historial</p>
          {(d.events || []).length === 0 ? <p className="text-sm text-muted-foreground">El cliente todavía no ha hecho nada en su portal.</p> : d.events.map((e) => (
            <div key={e.id} className="flex gap-3 text-sm border-b last:border-0 pb-2" data-testid={`activity-event-${e.id}`}>
              <span className="text-xs text-muted-foreground w-36 shrink-0">{fmt(e.at)}</span>
              <span className="whitespace-pre-line flex-1">{e.text}</span>
              {e.user_name && <span className="text-xs text-muted-foreground shrink-0" data-testid={`activity-event-user-${e.id}`}>{e.user_name}</span>}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
